import type { BaseParameters } from '../../interfaces/common/base-parameters';

export const BASE_PARAMETERS_KEYS: (keyof BaseParameters)[] = [
  'adrClasses',
  'hasHaccp',
  'hasHdsCrane',
  'hooksNumber',
  'hasCustomsSecuringRope',
  'matsNumber',
  'hasLoadingsRamps',
  'beltsNumber',
  'hasSanitaryInspection',
  'temperatureRange',
  'hasTailLift',
  'hasDumpContainer',
  'hasForklift',
  'otherVehicleParameters',
] as const;
